import * as React from 'react';

// tslint:disable-next-line no-any
const useResetDrivePage = (deps: any[]) => {
	const [shouldResetDrivePage, setShouldResetDrivePage] = React.useState(false);

	React.useEffect(() => {
		setShouldResetDrivePage(true);
		setTimeout(() => {
			setShouldResetDrivePage(false);
		}, 0);
	}, deps);

	return shouldResetDrivePage;
};

export default useResetDrivePage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/customHooks/useResetDrivePage.ts